<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-05 11:45:21
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveType\components\newNotice.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-22 10:01:09
-->
<template>
  <normalDialog
    :title="$t('label_essweb_leaveType_form_dialog_editNotice')"
    :dialog="show"
    @close="closeDialog"
    width="600"
    scrollable
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              textArea
              :bindData="notice"
              :TrigerInit="show"
              maxlength="500"
              @change="
                (valueArr) => {
                  notice = valueArr;
                }
              "
              :label="$t('label_essweb_leaveType_form_dialog_noticeLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="toNew" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newNotice",
  computed: {
    ...mapGetters(["companyLang"]),
  },
  props: {
    show: { default: false, type: Boolean },
    PropertyData: { default: null, type: Object },
  },
  data() {
    return { notice: "", number: null };
  },
  watch: {
    show(val) {
      if (!val) {
        this.notice = this.$getCommonLangKey(this.companyLang);
        this.number = null;
      }
    },
    PropertyData(val) {
      const that = this;
      if (val) {
        this.$Sleep(400).then(() => {
          // 加延迟解决国际化输入问题
          that.number = val.number;
          that.notice = that.$transOnLineCommonLangKey(
            that.companyLang,
            val["leave_type_notice_point_" + val.number]
          );
        });
      } else {
        this.notice = this.$getCommonLangKey(this.companyLang);
      }
    },
  },
  mounted() {
    // this.notice = this.$getCommonLangKey(this.companyLang);
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    toNew: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onNew", this.notice, this.number);
    },
  },
};
</script>
